import React from 'react';
import { AboutPage } from '../landing/AboutPage';

export function AboutView() {
    return <AboutPage />;
}
